<template>
  <section>
    <div class="p-3">
      <b-row class="mb-3">
        <b-col>
          <b-button size="sm" variant="primary" @click="add">
            Add
          </b-button>
        </b-col>
      </b-row>
      <b-row class="py-1 border-top" v-for="identity in sortedIdentities" :key="identity.tableauAuthConfigId">
        <b-col cols="6" lg="3">{{identity.tableauAuthConfigId}} </b-col>
        <b-col>{{identity.userName}}</b-col>
        <b-col cols="3">
          <b-button class="ml-2 float-right" variant="outline-primary" size="sm" @click="deleteItem(identity.tableauAuthConfigId)"><b-icon-trash/></b-button>
          <b-button class="ml-2 float-right" variant="outline-primary" size="sm" @click="edit(identity)"><b-icon-pencil/></b-button>
        </b-col>
      </b-row>
    </div>

    <b-modal
        v-model="showModal"
        centered
        hide-header
        hide-footer
        size="md"
        lazy
    >
      <div>
        <b-form ref="mainForm" @submit="submit">
          <b-row class="mb-3">
            <b-col cols="6" lg="3">Key</b-col>
            <b-col>
              <b-form-input v-model="formItems.tableauAuthConfigId" maxLength="50" required size="sm" :disabled="isEdit"/>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="6" lg="3">UserName</b-col>
            <b-col>
              <b-form-input v-model="formItems.userName" maxLength="200" required size="sm" type="email"/>
            </b-col>
          </b-row>
        </b-form>
        <b-row class="mb-3">
          <b-col>
            <b-button class="float-right" size="sm" variant="primary" @click="submit">Submit</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </section>
  
</template>

<script>
import TableauIdentitiesServices from "../../services/tableauIdentitiesServices";
import _ from "lodash";
import notification from "../../mixins/notification";
export default {
  name: "TableauIdentities",
  mixins: [notification],
  mounted() {
    this.getTableauIdentities();
  },
  data() {
    return {
      identities: [],
      formItems: {
        tableauAuthConfigId: '',
        userName: '',
      },
      
      isEdit: false,
      showModal: false,
    }
  },
  computed: {
    sortedIdentities() {
      return _.orderBy(this.identities,['tableauAuthConfigId']);
    },
  },
  methods : {
    add() {
      this.formItems = {tableauAuthConfigId: '', userName: ''};
      this.isEdit = false;
      this.showModal = true;
    }, 
    edit(item) {
      this.formItems = _.cloneDeep(item);
      this.isEdit = true;
      this.showModal = true;
    },
    async getTableauIdentities() {
      const resp = await TableauIdentitiesServices.getList();
      if(resp.data) {
        this.identities = resp.data;
      }
    },
    async submit() {
      const form = this.$refs.mainForm;
      if(!form.reportValidity())
        return;
      
      if(this.isEdit) {
        const confirm = await this.$bvModal.msgBoxConfirm('Proceed to edit the identity?', {centered: true});
        if (confirm) {
          await TableauIdentitiesServices.edit(this.formItems);
          await this.getTableauIdentities();
          this.PromptSuccess(
              'Success',
              'Identity had been edited successfully.'
          );
          this.showModal = false;
        }
      }
      else {
        const confirm = await this.$bvModal.msgBoxConfirm('Proceed to create the identity?', {centered: true});
        if (confirm) {
          await TableauIdentitiesServices.create(this.formItems);
          await this.getTableauIdentities();
          this.PromptSuccess(
              'Success',
              'Identity had been created successfully.'
          );
          this.showModal = false;
        }
      }
    },
    async deleteItem(id) {
      const confirm = await this.$bvModal.msgBoxConfirm('Proceed to delete the identity?', {centered: true});
      if (confirm) {
        await TableauIdentitiesServices.delete(id);
        await this.getTableauIdentities();
        this.PromptSuccess(
            'Success',
            'Identity had been deleted successfully.'
        );
      }
    },
  }
}
</script>


<style scoped>

</style>